module.exports = "<h3>Message coming from service</h3>\r\n<h4>title: {{title}}</h4>\r\n<h4>description: {{description}}</h4>\r\n<h4>webApiHostName: {{webApiHostName}}</h4>\r\n<h4>dataApiHostName: {{dataApiHostName}}</h4>\r\n<button (click)=\"getMessage()\">Get Message</button>\r\n<p>{{error}}</p>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/helloWorld/helloWorld.component.html
// module id = ./src/app/helloWorld/helloWorld.component.html
// module chunks = app